import { register } from "../../../../../node_modules/@akqa-group/vcp-barometer/dist/vcp-barometer";

const $window = $(window);
const $barometerWrapper = $(".barometer-wrapper");
const $barometerContainer = $barometerWrapper.find("#barometer");
const $inputBarometerCountry = $barometerWrapper.find(".barometer-country");
const $countryCounter = $barometerWrapper.find(".barometer-notice .counter");
const $inputBarometerType = $barometerWrapper.find("input[name='barometer-type']");
const $inputQuestionGroup = $barometerWrapper.find("input[name='barometer-question-group']");
const $filterModal = $barometerWrapper.find("#barometerFilterModal");
const $quickAccessModal = $barometerWrapper.find("#barometerQuestionModal");
let scrolled = false;

/**
* Creates and appends a barometer graph to the barometer container.
*
* @param {string} question - The question string used to generate URLs for the graph.
* @param {Array<string>} countryList - A list of country codes to be included in the graph.
* @param {number} index - The index of the current graph, used to determine styling.
*/
function createGraph(question, countryList, index) {
    const $newChartContainer = $("<div class='barometer-chart-container'><barometer-chart /></div>");
    const $newBarometerChart = $newChartContainer.find("barometer-chart");
    const urls = [];

    if (index % 2 === 0) {
        $newBarometerChart.attr("is-background-white", "");
    }

    $.each(countryList, function (_, country) {
        const updatedString = replaceUrlSegments(question, country);

        urls.push(updatedString);
    });

    $newBarometerChart.attr("jsons", JSON.stringify(urls));
    $barometerContainer.append($newChartContainer);
}

/**
* Loads and initializes the barometer graphs based on the initial questions and country.
* @returns {void}
*/
function loadInitialGraphs() {
    const questions = getQuestionValues().split(",");
    const countryList = $barometerContainer.attr("data-is-international") === "true"
        ? $barometerContainer.attr("data-international-countries").split(",")
        : $barometerContainer.attr("data-initial-country").split(",");

    $barometerContainer.empty();

    $.each(questions, function (index, question) {
        createGraph(question, countryList, index);
    });
}

/**
* Retrieves the selected barometer type from the input elements.
* @returns {string} The value of the checked input element within the barometer type parent container.
*/
function getType() {
    return $inputBarometerType.parent().find("input:checked").val();
}

/**
* Retrieves the values of checked country inputs from the barometer form.
* @returns {Array<string>} An array of values from the checked country inputs.
*/
function getCountryValues() {
    return $inputBarometerCountry
        .find(".input-item.checked")
        .map(function () {
            return $(this).find("input").val();
        })
        .get();
}

/**
* Retrieves the checked input elements within the same parent container as the question group.
* @returns {jQuery} - A jQuery collection of checked input elements within the parent container.
*/
function getQuestionGroupChecked() {
    return $inputQuestionGroup.parent().find("input:checked");
}

/**
* Retrieves the values of the checked question group.
* @returns {string} The value of the checked question group.
*/
function getQuestionValues() {
    return getQuestionGroupChecked().val();
}

/**
* Scrolls the page to the first chart in the barometer container.
* Takes into account the height of a sticky header if present.
*/
function scrollToFirstChart() {
    const stickyHeight = $(".sticky-head").height() || 0;
    const position = $barometerContainer.offset().top - stickyHeight;

    $("html, body").animate({ scrollTop: position }, 1000);
}

/**
* Handles the update of the barometer chart by setting various data attributes,
* creating graphs for each question, and updating the UI elements accordingly.
* @returns {void}
*/
function handleUpdateChart() {
    const type = getType();
    const $questionGroupChecked = getQuestionGroupChecked();

    $barometerContainer.attr("data-type", type).attr("data-last-type", type);
    $barometerContainer.attr("data-country", getCountryValues());
    $barometerContainer.attr("data-questions", getQuestionValues());
    $barometerContainer.attr("data-question-group", $questionGroupChecked.attr("id"));

    const $filterViewCTA = $barometerWrapper.find(".filter-view");
    const $quickAccessCTA = $barometerWrapper.find(".quick-access");
    const questions = $barometerContainer.attr("data-questions").split(",");
    const isInternational = $barometerContainer.attr("data-is-international") === "true";
    const initialCountry = isInternational && type === "MC" ? $barometerContainer.attr("data-international-countries") : $barometerContainer.attr("data-initial-country");
    const selectedCountries = $barometerContainer.attr("data-country");
    const initialQuestionGroup = $barometerContainer.attr("data-initial-question-group");
    const countryList = selectedCountries.split(",");
    const isSelectedInitialCountry = selectedCountries === initialCountry;
    const isSelectedInitialQuestionGroup = $questionGroupChecked.attr("id") === initialQuestionGroup;

    $barometerContainer.empty();

    $.each(questions, function (index, question) {
        createGraph(question, countryList, index);
    });

    $filterViewCTA.toggleClass("filtered", !isSelectedInitialCountry);
    $quickAccessCTA.toggleClass("filtered", !isSelectedInitialQuestionGroup);
    closeModal();
    scrollToFirstChart();
}

/**
* Replaces segments of a URL with new values based on the provided question and country.
* @param {string} question - The question identifier to be included in the URL.
* @param {string} country - The country code to be included in the URL.
* @returns {string} The updated URL with the new segments.
*/
function replaceUrlSegments(question, country) {
    const url = $barometerContainer.attr("data-url");
    const type = $barometerContainer.attr("data-type");
    const language = $barometerContainer.attr("data-language");
    const lastSlashIndex = url.lastIndexOf("/");
    const jsonIndex = url.lastIndexOf(".json");
    const beforeLastSegment = url.substring(0, lastSlashIndex + 1);
    const afterJson = url.substring(jsonIndex);
    const updatedLastSegment = `${type}-${question}_${language}-${country}`;

    return beforeLastSegment + updatedLastSegment + afterJson;
}

/**
* Sets an interval to continuously check for the presence of a modal backdrop element.
* Once the modal backdrop is found, it clears the interval and attaches a click event handler to close the modal.
*/
function setCloseModalOnBackDrop() {
    const interval = setInterval(() => {
        const $modalBackdrop = $(".modal-backdrop");

        if ($modalBackdrop.length > 0) {
            clearInterval(interval);
            $modalBackdrop.on("click", closeModal);
        }
    }, 0);
}

/**
* Initializes the filter modal for the barometer graph.
*/
function handleInitFilterModal() {
    const $filterViewCTA = $barometerWrapper.find(".filter-view-cta");

    $quickAccessModal.find(".close").trigger("click");
    $filterViewCTA.addClass("active");
    setCloseModalOnBackDrop();
    setTimeout(handleDynamicMaxHeight, 0);
}


/**
* Initializes the Quick Access Modal
*/
function handleInitQuickAccessModal() {
    const $quickAccessCTA = $barometerWrapper.find(".quick-access-cta");

    $filterModal.find(".close").trigger("click");
    $quickAccessCTA.addClass("active");
    setCloseModalOnBackDrop();
}

/**
* Handles the sticky behavior of the barometer element on the page.
* This function checks the scroll position and adjusts the position of the barometer element
* based on whether the view is on a desktop or a mobile device. It also manages the visibility
* and positioning of the "back to top" button.
*
* @returns {void}
*/
function handleStickyBar() {
    if (!scrolled) {
        scrolled = true;
        const isDesktop = window.innerWidth >= 768;
        const $barometerSticky = $barometerWrapper.find(".barometer-sticky");
        const $backToTop = $(".back-to-top");

        if (!isDesktop) {
            const containerRect = $barometerWrapper[0].getBoundingClientRect();
            const stickyRect = $barometerSticky[0].getBoundingClientRect();

            if (containerRect.top <= 0 && containerRect.bottom >= stickyRect.height) {
                $barometerSticky.addClass("fixed");

                if (!$backToTop.hasClass("d-none")) {
                    $backToTop.addClass("sticky-barometer");
                }
            } else {
                $barometerSticky.removeClass("fixed");
                $backToTop.removeClass("sticky-barometer");
            }
        } else {
            const baseTop = 20;
            const stickyHeight = $(".sticky-head").outerHeight(true) || 0;
            const position = baseTop + stickyHeight;

            $barometerSticky.css("top", position + "px");
        }

        setTimeout(() => {
            scrolled = false;
        }, 500);
    }
}

/**
* Initializes event listeners for various elements related to the barometer graph.
* Sets up handlers for changes, clicks, modal events, window resize, and scroll events.
* Also triggers the reset filter modal handler upon initialization.
*/
function initEvents() {
    const $barometerFilterCTA = $barometerWrapper.find(".barometer-filter-cta");
    const $barometerQuestionsCTA = $barometerWrapper.find(".barometer-questions-cta");

    $inputBarometerType.on("change", handleBarometerTypeChange);
    $inputBarometerCountry.on("change", "input", handleBarometerCountrySelection);
    $barometerFilterCTA.on("click", handleUpdateChart);
    $barometerQuestionsCTA.on("click", handleUpdateChart);
    $filterModal.on("hidden.bs.modal", handleResetFilterModal);
    $filterModal.on("show.bs.modal", handleInitFilterModal);
    $quickAccessModal.on("hidden.bs.modal", handleResetQuestionModal);
    $quickAccessModal.on("show.bs.modal", handleInitQuickAccessModal);
    $window.on("resize", handleDynamicMaxHeight);
    $window.on("scroll", handleStickyBar);

    handleResetFilterModal();
}

/**
* Handles the visibility of country-specific barometer notices based on the provided type.
* This function toggles the visibility of elements within the barometer country wrapper
* based on whether their data-types attribute includes the specified type. It ensures that
* only the relevant notices are displayed.
* @param {string} type - The type used to filter and display the relevant barometer notices.
*/
function handleVisibilityCountryWrapper(type) {
    const $barometerCountryWrapper = $barometerWrapper.find(".barometer-country-wrapper");
    const $barometerNotices = $barometerCountryWrapper.find(".barometer-notice");

    $barometerNotices.each(function () {
        const $notice = $(this);

        $notice.toggleClass("d-none", !$notice.data("types").includes(type));
    });

    $barometerCountryWrapper.removeClass("d-none");
}

/**
* Handles the reset of the filter modal for the barometer graph.
* This function resets the filter view to its last selected type, updates the input type,
* and manages the visibility of the country wrapper based on the selected type.
*/
function handleResetFilterModal() {
    const $filterCTA = $barometerWrapper.find(".filter-view-cta");
    const type = $barometerContainer.attr("data-last-type");

    $filterCTA.removeClass("active");
    $inputBarometerType.parent().find(`[value=${type}]`).prop("checked", true);
    changeInputType(type);
    handleVisibilityCountryWrapper(type);
}

/**
* Resets the question modal to its default state
* @returns {void}
*/
function handleResetQuestionModal() {
    const $quickAccessCTA = $barometerWrapper.find(".quick-access-cta");
    const questionGroup = $barometerContainer.attr("data-question-group");

    $(`#${questionGroup}`).prop("checked", true);
    $quickAccessCTA.removeClass("active");
}

/**
* Closes the modal by triggering a click event on the close button.
* This function finds the close button within the barometer wrapper and simulates a click event to close the modal.
*/
function closeModal() {
    $barometerWrapper.find(".close").trigger("click");
}

/**
* Handles the change event for the barometer type selection.
* This function updates the input type, manages the visibility of the country wrapper,
* and adjusts the dynamic maximum height based on the selected barometer type.
*/
function handleBarometerTypeChange() {
    const $this = $(this);
    const type = $this.val();

    if ($this.is(":checked")) {
        changeInputType(type);
        handleVisibilityCountryWrapper(type);
        handleDynamicMaxHeight();
    }
}

/**
* Toggles the 'disabled' class on the barometer filter call-to-action (CTA) element
* based on the provided enable parameter.
* @param {boolean} enable - A flag indicating whether to enable or disable the CTA.
*/
function handleVisibilityFilterCTA(enable) {
    const $filterCTA = $barometerWrapper.find(".barometer-filter-cta");

    $filterCTA.toggleClass("disabled", !enable);
}

/**
* Updates the country counter displayed in the barometer graph.
* @param {boolean} isIncrease - Determines whether to increase or decrease the counter.
* @returns {void}
*/
function updateCount(isIncrease) {
    const value = parseInt($inputBarometerCountry.attr("data-country-counter"), 10);
    const newValue = value + (isIncrease ? 1 : -1);

    $inputBarometerCountry.attr("data-country-counter", newValue);
    $countryCounter.text(newValue);
}

/**
* Validates the country selection based on the input type.
* @param {boolean} isCheckbox - Indicates if the input is a checkbox.
* @returns {boolean} - Returns true if the country selection is valid, otherwise false.
*/
function isValidCountrySelection(isCheckbox) {
    const value = parseInt($inputBarometerCountry.attr("data-country-counter"), 10);

    return isCheckbox ? value >= 2 && value <= 10 : value === 1;
}

/**
* Handles the selection of a country in the barometer graph, updating the UI and count accordingly.
* @returns {void}
*/
function handleBarometerCountrySelection() {
    const $input = $(this);
    const isCheckbox = $input.attr("type") === "checkbox";

    if (isCheckbox) {
        if ($input.is(":checked")) {
            updateCount(true);
            $input.parent().addClass("checked");
        } else {
            updateCount(false);
            $input.parent().removeClass("checked");
        }
    } else {
        $(".input-item").removeClass("checked");
        $input.parent().addClass("checked");
    }

    handleVisibilityFilterCTA(isValidCountrySelection(isCheckbox));
}

/**
* Resets the country counter displayed in the barometer graph.
*/
function resetCountryCounter() {
    $countryCounter.text(0);
    $inputBarometerCountry.attr("data-country-counter", 0);
}

/**
* Changes the input type of country selection elements and updates their state accordingly.
* @param {string} type - The type of input to switch to ("MC" for "checkbox", otherwise "radio").
*/
function changeInputType(type) {
    const inputType = type === "MC" ? "checkbox" : "radio";
    const isInternational = $barometerContainer.attr("data-is-international") === "true";
    const countries = $barometerContainer.attr("data-country").split(",");
    const internationalCountries = $barometerContainer.attr("data-international-countries").split(",");
    const previousType = $barometerContainer.attr("data-last-type");
    const initialCountry = $barometerContainer.attr("data-initial-country");
    const isCheckbox = inputType === "checkbox";
    const isInitialInternationalCountries = isInternational && countries.length === 1 && isCheckbox;

    resetCountryCounter();
    handleVisibilityFilterCTA(false);

    $(".input-item").each(function () {
        const $this = $(this);
        const $input = $this.find("input");
        const radioInitialCountry = !isCheckbox && previousType === "MC" && initialCountry === $input.val();
        const isSameCountry = isInitialInternationalCountries
            ? internationalCountries.includes($input.val())
            : countries.includes($input.val());

        $input.attr("type", inputType);
        $input.prop("disabled", false);

        const shouldCheck = isSameCountry
            ? (isCheckbox && previousType === "MC") || (!isCheckbox && previousType !== "MC") || isInitialInternationalCountries || radioInitialCountry
            : radioInitialCountry;
        $input.prop("checked", shouldCheck);
        $this.toggleClass("checked", shouldCheck);

        if (shouldCheck) {
            updateCount(true);
        }
    });

    handleVisibilityFilterCTA(isValidCountrySelection(isCheckbox));
}

/**
* Adjusts the maximum height of the barometer country input field dynamically based on the modal's visibility and screen size.
* This function calculates various elements' heights and margins within the modal to set an appropriate max height for the input field.
*
* @returns {void}
*/
function handleDynamicMaxHeight() {
    if ($filterModal.hasClass("show")) {
        const isDesktop = window.innerWidth >= 768;
        const isDVH = CSS.supports("height", "100dvh");
        const $modal = $barometerWrapper.find(".modal-content");
        const $basicModal = $barometerWrapper.find(".basic-modal.show");
        const $barometerType = $modal.find(".barometer-type");
        const $barometerCountryWrapper = $modal.find(".barometer-country-wrapper");
        const $closeBtn = $modal.find(".close");
        const $barometerHeader = $modal.find(".barometer-header");
        const $barometerNotice = $modal.find(".barometer-notice:not(.d-none)");
        const $barometerActions = $modal.find(".barometer-actions");

        const modalPaddingTop = parseFloat($modal.css("padding-top"));
        const modalPaddingBottom = parseFloat($modal.css("padding-bottom"));
        const closeHeight = $closeBtn.height();
        const barometerHeaderHeight = !isDesktop ? $barometerHeader.height() : 0;
        const countryWrapperMarginTop = parseFloat($barometerCountryWrapper.css("margin-top"));
        const barometerTypeHeight = $barometerType.height();
        const barometerTypeMarginTop = parseFloat($barometerType.css("margin-top"));
        const barometerNoticePaddingTop = parseFloat($barometerNotice.css("padding-top"));
        const barometerNoticeHight = $barometerNotice.height();
        const barometerCountryMarginTop = parseFloat($inputBarometerCountry.css("margin-top"));
        const barometerActionsHeight = $barometerActions.height();
        const barometerActionsPaddingTop = parseFloat($barometerActions.css("padding-top"));
        const modalBottom = parseFloat($basicModal.css("bottom"));
        const baseHeight = `${isDesktop ? 80 : 100}${isDVH ? "dvh" : "vh"}`;

        const totalHeight =
            modalPaddingTop +
            modalPaddingBottom +
            closeHeight +
            barometerHeaderHeight +
            countryWrapperMarginTop +
            barometerTypeHeight +
            barometerTypeMarginTop +
            barometerNoticePaddingTop +
            barometerNoticeHight +
            barometerCountryMarginTop +
            barometerActionsHeight +
            barometerActionsPaddingTop +
            modalBottom;

        $inputBarometerCountry.css("maxHeight", `calc(${baseHeight} - ${totalHeight}px)`);
    }
}

$(document).ready(function () {
    initEvents();
    loadInitialGraphs();
    register();
});
